import { useMutation, useQueryClient } from '@tanstack/react-query'
import { FRAUD_CASES } from 'api/react-query/keys'
import { closeFraudCase, markFraudCaseAsNotified, markTransactionAsFraud, markTransactionAsNotFraud } from './endpoints'

export const useMarkAsNotified = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (caseId: string) => markFraudCaseAsNotified(caseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRAUD_CASES] })
    },
  })
}

export const useCloseFraudCase = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (caseId: string) => closeFraudCase(caseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRAUD_CASES] })
    },
  })
}

export const useMarkTransactionAsFraud = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ caseId, transactionId }: { caseId: string; transactionId: string }) => markTransactionAsFraud(caseId, transactionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRAUD_CASES] })
    },
  })
}

export const useMarkTransactionAsNotFraud = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ caseId, transactionId }: { caseId: string; transactionId: string }) => markTransactionAsNotFraud(caseId, transactionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRAUD_CASES] })
    },
  })
}
